import $ from '../tools/Dom';

export default el => {
    const dom = $(el);

    const onClick = e => {
        if (typeof window.Intercom !== 'function') {
            return;
        }

        e.preventDefault();
        window.Intercom('show');
    };

    const init = () => {
        dom.on('click', onClick);
    };

    const destroy = () => {
        dom.off('click', onClick);
    };

    return {
        init,
        destroy
    };
};
